import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { getDynamicRouteLink, getRouterLinkUrlById } from '@lsq-frontend/common-ui';
import {
    Prospect,
    ProspectService,
    SchemaService,
    StageData,
    StageSchema
} from '@lsq-frontend/remote-services/ar-app';
import { ADMIN_DOCUMENTS_AUDIT, atlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { DrApplicationService } from '../../service/dr-application-service';

@Component({
    selector: 'dr-tab',
    templateUrl: './dr-tab.component.html',
    styleUrls: ['./dr-tab.component.scss']
})
export class DynamicTab {
    @Input() dynamicRouterLink;
    @Input() formGroup: FormGroup;
    @Input() rowView: Boolean;
    @Input() reviewMode: Boolean;
    @Input() adminMode: Boolean;
    @Input() viewedBy: string = 'both';
    @Input() schemaType: string;
    @Input() companyKey: string;
    public stageSchemas: StageSchema[];
    public stageSchema: StageSchema;
    public stageData: StageData;
    public prospectId: string;
    public tabsConfig = [];
    public noData: boolean = false;
    public loading = true;
    public isAudit: boolean;
    public totalOpenStage: number;

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _arService: DrApplicationService,
        private _prospectService: ProspectService,
        private _schemaService: SchemaService
    ) {}

    public async ngOnInit(): Promise<void> {
        let stageName;

        await this.fetchProspect(this.companyKey);
        this._activatedRoute.queryParams.subscribe((queryParams) => {
            this.stageSchemas = this._arService.getProspectSchema().stageSchemas;

            // If is audit
            if (this._router.url.indexOf('/audit') > -1) {
                this.isAudit = true;
            } else {
                this.isAudit = false;
                // Set the default tab's query param by default if none selected.
                if (!queryParams.show && this._router.url.indexOf('/audit') <= -1) {
                    this._router.navigate([this._router.url], {
                        queryParams: { show: this.stageSchemas[0]?.name }
                    });
                } else {
                    this.loadData(queryParams.show);
                }
                stageName = queryParams.show;
            }
        });
        this._arService.prospectSchemaSubject.subscribe(() => {
            if (this.schemaType === this._arService.documentCenterName) {
                if (stageName) this.loadData(stageName);
                this._arService.getTotalOpenStageCount();
                this.setTabsConfig();
            }
        });
    }

    public async fetchProspect(companyKey: string): Promise<void> {
        if (this.schemaType === this._arService.documentCenterName) {
            try {
                const getProspect = this._prospectService.getProspectDataByCompanykeyAndSchematype(
                    companyKey,
                    Prospect.SchemaTypeEnum.DocumentCenter
                );
                const prospectData = await getProspect.toPromise();
                if (!prospectData) {
                    return;
                }
                this._arService.setProspect(prospectData);
                const getProspectSchema = this._schemaService.getProspectSchema(
                    prospectData.prospectSchemaId
                );
                this.prospectId = prospectData.id;
                const schemaData = await getProspectSchema.toPromise();
                this._arService.setProspectSchema(schemaData[0]);
            } catch (e) {
                this.noData = true;
            }
            this.loading = false;
        }
    }

    public loadData(stageName?) {
        if (this.schemaType === this._arService.documentCenterName) {
            var prospectData = this._arService.getProspect();
            this.initStages();
            this.stageSchema = this._arService
                .getProspectSchema()
                .stageSchemas.find((stageSchema: StageSchema) => stageSchema.name === stageName);
            if (this.stageSchema) {
                this._arService.setDocumentsStageID(this.stageSchema.id);
                this.stageData = prospectData.stages[this.stageSchema.id];
            }
            if (Object.keys(this.stageData?.fields).length === 0) {
                this.noData = true;
            }
        }
    }

    public initStages() {
        this._arService.initStages();
    }

    public setTabsConfig(): void {
        const companyKey = this.companyKey;
        this.tabsConfig = [];
        for (const stageSchema of this.stageSchemas) {
            this.tabsConfig.push({
                label: stageSchema.label,
                routerLink: this.dynamicRouterLink,
                queryParams: {
                    show: stageSchema.name
                },
                counter:
                    stageSchema.name === this._arService.openRequestName
                        ? this._arService.getOpenRequestTotalDocuments()
                        : null
            });
        }
        if (this.viewedBy === 'admin') {
            this.tabsConfig.push({
                label: 'Audit',
                routerLink: getDynamicRouteLink(
                    getRouterLinkUrlById(atlas, ADMIN_DOCUMENTS_AUDIT),
                    {
                        companyKey
                    }
                )
            });
        }
    }
}
